import { filterSidebarMenuItems } from 'src/app/config/master-merge-feature.flags';
import {
  EMISYON_FAKTORLERI_FEATURE_PERMISSIONS,
  GOREV_PANOSU_FEATURE_PERMISSIONS,
  HESAPLAMA_FEATURE_PERMISSIONS,
  MUHASEBE_FEATURE_PERMISSIONS,
  MUHASEBE_YARDIMCI_DEFTER_PERMISSIONS,
  P,
  RAPORLAR_FEATURE_PERMISSIONS,
  SU_AYAK_IZI_FEATURE_PERMISSIONS,
  YONETIM_FEATURE_PERMISSIONS,
} from 'src/app/config/portal-permissions.constants';

const SIDEBAR_MENU_ITEMS = [
  //Home
  {
    id: 'dashboard',
    type: 'section',
    title: 'Home',
    branch: '',
    translate: 'MENU.HOME.SECTION',
    role: ['Admin', 'ApplicationAdmin', 'SuperAdmin', 'User'],
    permission: [],
    permissions: [P.Analiz.GenelBakis],
    icon: 'fs-2 ki-outline ki-home',
    activeIcon: '../../../../../../assets/media/icons/jtricons/home-active.svg',
    url: '/home',
    exactMatch: true,
    activeUrl: false,
    openInNewTab: false,
  },

  {
    id: 'dashboard-task',
    type: 'section',
    title: 'Home',
    branch: '',
    translate: 'MENU.HOME.DASHBOARD_TASK',
    role: ['Admin', 'ApplicationAdmin', 'SuperAdmin', 'User'],
    permission: [],
    permissions: [P.GorevPanosu.Module, ...GOREV_PANOSU_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-check-square',
    activeIcon: '../../../../../../assets/media/icons/jtricons/home-active.svg',
    url: '/dashboard-task',
    activeUrl: false,
  },
  // {
  //   id: 'emissiondata',
  //   type: 'section',
  //   title: 'EmissionData',
  //   branch: '',
  //   translate: 'MENU.EMISSIONDATA.SECTION',
  //   role: ['Admin', 'ApplicationAdmin'],
  //   permission: ['testpermission'],
  //   icon: 'fs-2 ki-outline ki-data',
  //   activeIcon: '../../../../../../assets/media/icons/jtricons/jtr-lab-active.svg',
  //   url: '/emission-data',
  //   activeUrl: false,
  // },
  //Admin — Yönetim (header tab'larıyla aynı alt menü)
  {
    id: 'admin',
    type: 'section',
    title: 'Admin',
    branch: '',
    translate: 'MENU.ADMIN.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
    permission: [''],
    permissions: [...YONETIM_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-user',
    activeIcon:
      '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
    activeUrl: false,
    children: [
      {
        id: 'admin-my-company',
        type: 'item',
        title: 'My Company',
        translate: 'MENU.ADMIN.MYCOMPANY',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.Sirketim],
        icon: 'fs-2 ki-outline ki-office-bag',
        url: '/admin/my-company',
        activeUrl: false,
      },
      {
        id: 'admin-users',
        type: 'item',
        title: 'User Management',
        translate: 'MENU.ADMIN.USERMANAGEMENT',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.Kullanicilar],
        icon: 'fs-2 ki-outline ki-people',
        url: '/admin/users',
        activeUrl: false,
      },
      {
        id: 'admin-roles',
        type: 'item',
        title: 'Roles',
        translate: 'MENU.ADMIN.ROLES',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.Roller],
        icon: 'fs-2 ki-outline ki-user-square',
        url: '/admin/roles',
        activeUrl: false,
        // Header ile aynı: sadece şirket bağlamı olmayan non-superAdmin
        adminRolesNavOnly: true,
      },
      {
        id: 'admin-locations',
        type: 'item',
        title: 'Locations',
        translate: 'MENU.ADMIN.LOCATIONS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.Lokasyonlar],
        icon: 'fs-2 ki-outline ki-geolocation',
        url: '/admin/locations',
        activeUrl: false,
      },
      {
        id: 'admin-sub-companies',
        type: 'item',
        title: 'Sub Companies',
        translate: 'MENU.ADMIN.SUBCOMPANY',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.AltSirketler],
        icon: 'fs-2 ki-outline ki-bank',
        url: '/admin/sub-companies',
        activeUrl: false,
      },
      {
        id: 'admin-equipments',
        type: 'item',
        title: 'Equipments',
        translate: 'MENU.ADMIN.EQUIPMENTS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.Ekipmanlar],
        icon: 'fs-2 ki-outline ki-technology-4',
        url: '/admin/equipments',
        activeUrl: false,
      },
      {
        id: 'admin-wastewater',
        type: 'item',
        title: 'Wastewater Treatment',
        translate: 'MENU.ADMIN.WASTEWATERTREATMENT',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Yonetim.AtiksuTesisleri],
        icon: 'fs-2 ki-outline ki-drop',
        url: '/admin/wastewater-treatment-facilities',
        activeUrl: false,
      },
    ],
  },
  //Applications (tenant yonetimi - sadece SuperAdmin)
  {
    id: 'applications',
    type: 'section',
    title: 'Applications',
    branch: '',
    translate: 'MENU.APPLICATIONMANAGEMENT.SECTION',
    role: ['SuperAdmin'],
    roleOnly: true,
    permission: [''],
    permissions: [],
    icon: 'fs-2 ki-outline ki-abstract-26',
    activeIcon:
      '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
    activeUrl: false,

    children: [
      {
        id: 'applications-list',
        type: 'item',
        title: 'Applications',
        translate: 'MENU.APPLICATIONMANAGEMENT.APPLICATIONS',
        role: ['SuperAdmin'],
        roleOnly: true,
        permission: [''],
        permissions: [],
        icon: 'fs-2 ki-outline ki-abstract-26',
        url: '/admin/applications',
        activeUrl: false,
      },
      {
        id: 'applications-ldap-settings',
        type: 'item',
        title: 'LDAP Settings',
        translate: 'MENU.APPLICATIONMANAGEMENT.LDAPSETTINGS',
        role: ['SuperAdmin'],
        roleOnly: true,
        permission: [''],
        permissions: [],
        icon: 'fs-2 ki-outline ki-security-user',
        url: '/admin/ldap-settings',
        activeUrl: false,
      },
      {
        id: 'applications-login-audit-log',
        type: 'item',
        title: 'Login Audit Log',
        translate: 'MENU.APPLICATIONMANAGEMENT.LOGINAUDITLOG',
        role: ['SuperAdmin', 'ApplicationAdmin'],
        roleOnly: true,
        permission: [''],
        permissions: [],
        icon: 'fs-2 ki-outline ki-shield-search',
        url: '/admin/login-audit-log',
        activeUrl: false,
      },
      {
        id: 'applications-aircraft',
        type: 'item',
        title: 'Aircraft',
        translate: 'MENU.APPLICATIONMANAGEMENT.AIRCRAFT',
        role: ['SuperAdmin'],
        roleOnly: true,
        permission: [''],
        permissions: [],
        icon: 'fs-2 ki-outline ki-airplane',
        url: '/admin/aircraft',
        activeUrl: false,
      },
      {
        id: 'applications-aviation-fuel-aliases',
        type: 'item',
        title: 'Aviation Fuel Aliases',
        translate: 'MENU.APPLICATIONMANAGEMENT.AVIATIONFUELALIASES',
        role: ['SuperAdmin'],
        roleOnly: true,
        permission: [''],
        permissions: [],
        icon: 'fs-2 ki-outline ki-drop',
        url: '/admin/aviation-fuel-aliases',
        activeUrl: false,
      },
    ],
  },
  //Calculation
  {
    id: 'calculation',
    type: 'section',
    title: 'Calculation',
    branch: '',
    translate: 'MENU.CALCULATION.DATA',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
    permission: [''],
    permissions: [...HESAPLAMA_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-data',
    activeIcon:
      '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
    // url: '/calculation',
    activeUrl: false,

    children: [
      {
        id: 'calculation',
        type: 'item',
        title: 'Calculation',
        translate: 'MENU.CALCULATION.SECTION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.Hesaplama.VeriGirisi, P.Hesaplama.VeriYukleme],
        icon: 'fs-2 ki-outline ki-finance-calculator',
        url: '/calculation',
        // bulk-upload de /calculation altında; sibling seçiliyken Hesaplama aktif olmasın
        activeExceptPrefixes: ['/calculation/bulk-upload'],
        activeUrl: false,
      },
      {
        id: 'emissionHisory',
        type: 'item',
        title: 'Emission Data History',
        translate: 'MENU.CALCULATION.DATAHISTORY',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.Hesaplama.GecmisYillar],
        icon: 'fs-2 ki-outline ki-time',
        url: '/emissiondata-prevyears',
        activeUrl: false,
      },
      {
        id: 'bulkUpload',
        type: 'item',
        title: 'Bulk Data Upload',
        translate: 'MENU.CALCULATION.BULK_UPLOAD',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.Hesaplama.TopluVeri],
        icon: 'fs-2 ki-outline ki-file-up',
        url: '/calculation/bulk-upload',
        activeUrl: false,
      },
    ],
  },
  {
    id: 'accounting',
    type: 'section',
    title: 'Accounting',
    translate: 'MENU.ACCOUNTING.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
    permission: [''],
    permissions: [...MUHASEBE_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-book',
    activeUrl: false,
    // Sira (kullanici karari 2026-07-23): Hesap Plani, Mizan, Yardimci Defterler, Muavin Merkezi,
    // Konsolidasyon, Sonuclar, EF Kutuphanesi (+ SuperAdmin'e ozel Kural Kutuphanesi en sonda).
    children: [
      {
        id: 'coaSetup',
        type: 'item',
        title: 'Chart of Accounts',
        translate: 'MENU.ACCOUNTING.COA_SETUP',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Muhasebe.HesapPlani, P.Muhasebe.HesapAgaci],
        icon: 'fs-2 ki-outline ki-book',
        url: '/accounting/coa-setup',
        activeUrl: false,
      },
      {
        id: 'accountingEmission',
        type: 'item',
        title: 'Trial Balance',
        translate: 'MENU.ACCOUNTING.EMISSION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Muhasebe.Emisyon],
        icon: 'fs-2 ki-outline ki-calculator',
        url: '/accounting/emission',
        activeUrl: false,
      },
      {
        id: 'accountingAuxLedgers',
        type: 'item',
        title: 'Auxiliary Ledgers',
        translate: 'MENU.ACCOUNTING.AUX_LEDGERS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [...MUHASEBE_YARDIMCI_DEFTER_PERMISSIONS],
        icon: 'fs-2 ki-outline ki-parcel',
        url: '/accounting/aux-ledgers',
        activeUrl: false,
      },
      {
        id: 'accountingLedger',
        type: 'item',
        title: 'Sub-ledger Center',
        translate: 'MENU.ACCOUNTING.LEDGER',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Muhasebe.Muavin],
        icon: 'fs-2 ki-outline ki-book-open',
        url: '/accounting/ledger',
        activeUrl: false,
      },
      {
        id: 'accountingConsolidation',
        type: 'item',
        title: 'Consolidation',
        translate: 'MENU.ACCOUNTING.CONSOLIDATION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Muhasebe.Konsolidasyon],
        icon: 'fs-2 ki-outline ki-abstract-26',
        url: '/accounting/consolidation',
        activeUrl: false,
      },
      {
        id: 'accountingResults',
        type: 'item',
        title: 'Results',
        translate: 'MENU.ACCOUNTING.RESULTS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Muhasebe.Sonuclar],
        icon: 'fs-2 ki-outline ki-chart-simple',
        url: '/accounting/results',
        activeUrl: false,
      },
      {
        id: 'accountingEfLibrary',
        type: 'item',
        title: 'EF Library',
        translate: 'MENU.ACCOUNTING.EF',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
        permission: [''],
        permissions: [P.Muhasebe.EfKutuphanesi],
        icon: 'fs-2 ki-outline ki-abstract-45',
        url: '/accounting/ef-library',
        activeUrl: false,
      },
      {
        id: 'accountingRules',
        type: 'item',
        title: 'Rule Library',
        translate: 'MENU.ACCOUNTING.RULES',
        role: ['SuperAdmin'],
        roleOnly: true,
        permission: [''],
        permissions: [],
        icon: 'fs-2 ki-outline ki-abstract-26',
        url: '/accounting/rules',
        activeUrl: false,
      },
      {
        id: 'accountingEfConsole',
        type: 'item',
        title: 'EF Console',
        translate: 'MENU.ACCOUNTING.EF_CONSOLE',
        role: ['SuperAdmin'],
        permission: [''],
        icon: 'fs-2 ki-outline ki-setting-3',
        url: '/accounting/ef-console',
        activeUrl: false,
      },
    ],
  },
  {
    id: 'reports',
    type: 'section',
    title: 'Reports',
    branch: '',
    translate: 'MENU.REPORTS.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
    permission: [''],
    permissions: [...RAPORLAR_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-notepad',
    activeIcon:
      '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
    activeUrl: false,
    children: [
      {
        id: 'reports-emission',
        type: 'item',
        title: 'Emission Report',
        translate: 'MENU.REPORTS.EMISSION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.Raporlar.Emisyon],
        icon: 'fs-2 ki-outline ki-graph-up',
        // url: '/reports/emission',
        url: '/reporting',
        activeUrl: false,
      },
      // {
      //   id: 'reports-uncertainty',
      //   type: 'item',
      //   title: 'Uncertainty Report',
      //   translate: 'MENU.REPORTS.UNCERTAINTY',
      //   role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
      //   permission: [''],
      //   icon: 'fs-2 ki-outline ki-information-2',
      //   url: '/reports/uncertainty',
      //   activeUrl: false,
      // },
    ],
  },

  // {
  //   id: 'calculation',
  //   type: 'section',
  //   title: 'Calculation',
  //   branch: '',
  //   translate: 'MENU.CALCULATION.SECTION',
  //   role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
  //   permission: [''],
  //   icon: 'fs-2 ki-outline ki-finance-calculator',
  //   activeIcon:
  //     '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
  //   url: '/calculation',
  //   activeUrl: false,
  //   children: [
  //     {
  //       id: 'fugitive',
  //       type: 'item',
  //       title: 'Fugitive Combustion',
  //       translate: 'MENU.CALCULATION.SECTION',
  //       role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
  //       permission: [''],
  //       icon: 'fs-2 ki-outline ki-finance-calculator',
  //       url: '/calculation',
  //       activeUrl: false,
  //     },
  //     {
  //       id: 'stationary',
  //       type: 'item',
  //       title: 'Stationary Combustion',
  //       translate: 'MENU.CALCULATION.SECTION',
  //       role: ['SuperAdmin', 'ApplicationAdmin', 'Admin'],
  //       permission: [''],
  //       icon: 'fs-2 ki-outline ki-finance-calculator',
  //       url: '/calculation',
  //       activeUrl: false,
  //     },
  //   ],
  // },
  {
    id: 'suppliers',
    type: 'section',
    title: 'Suppliers',
    branch: '',
    translate: 'MENU.SUPPLIERSS.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
    permission: [''],
    permissions: [P.Tedarikci.Module],
    icon: 'fs-2 ki-outline ki-shop',
    url: '/suppliers',
    activeUrl: false,
  },
  {
    id: 'water-footprint',
    type: 'section',
    title: 'Water Footprint',
    branch: '',
    translate: 'MENU.WATER_FOOTPRINT.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
    permission: ['Water'],
    permissions: [...SU_AYAK_IZI_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-ocean',
    activeIcon: '',
    url: '/water-footprint',
    activeUrl: false,
  },

  // Authorization (SuperAdmin — geçici ApplicationAdmin bypass)
  {
    id: 'authorization-admin',
    type: 'section',
    title: 'Authorization',
    branch: '',
    translate: 'MENU.AUTHORIZATION.SECTION',
    role: ['SuperAdmin'],
    requiresAuthorizationAdmin: true,
    permission: [],
    icon: 'fs-2 ki-outline ki-shield-tick',
    activeUrl: false,
    children: [
      {
        id: 'authorization-overview',
        type: 'item',
        title: 'Overview',
        translate: 'MENU.AUTHORIZATION.OVERVIEW',
        role: ['SuperAdmin'],
        requiresAuthorizationAdmin: true,
        permission: [],
        icon: 'fs-2 ki-outline ki-chart-simple',
        url: '/authorization/overview',
        activeUrl: false,
      },
      {
        id: 'authorization-permissions',
        type: 'item',
        title: 'Permissions',
        translate: 'MENU.AUTHORIZATION.PERMISSIONS',
        role: ['SuperAdmin'],
        requiresAuthorizationAdmin: true,
        permission: [],
        icon: 'fs-2 ki-outline ki-key',
        url: '/authorization/permissions',
        activeUrl: false,
      },
      {
        id: 'authorization-roles',
        type: 'item',
        title: 'Roles',
        translate: 'MENU.AUTHORIZATION.ROLES',
        role: ['SuperAdmin'],
        requiresAuthorizationAdmin: true,
        permission: [],
        icon: 'fs-2 ki-outline ki-people',
        url: '/authorization/roles',
        activeUrl: false,
      },
      {
        id: 'authorization-endpoints',
        type: 'item',
        title: 'API Endpoints',
        translate: 'MENU.AUTHORIZATION.ENDPOINTS',
        role: ['SuperAdmin'],
        requiresAuthorizationAdmin: true,
        permission: [],
        icon: 'fs-2 ki-outline ki-code',
        url: '/authorization/endpoints',
        activeUrl: false,
      },
    ],
  },

  //AplicationAdmin — Grup Şirketleri
  {
    id: 'applicationadmin',
    type: 'section',
    title: 'ApplicationAdmin',
    branch: '',
    translate: 'MENU.APPLICATIONADMIN.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin'],
    permission: [''],
    permissions: [P.UygulamaYonetimi.Sirketler],
    icon: 'fs-2 ki-outline ki-briefcase',
    activeIcon:
      '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
    url: '/applicationadmin/companies',
    activeUrl: false,
  },
  {
    id: 'integrations',
    type: 'section',
    title: 'Integrations',
    branch: '',
    translate: 'MENU.INTEGRATIONS.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin'],
    permission: [''],
    permissions: [P.UygulamaYonetimi.Entegrasyonlar],
    icon: 'fs-2 ki-outline ki-key',
    activeIcon:
      '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
    url: '/applicationadmin/integration-management',
    activeUrl: false,
  },
  // {
  //   id: 'hotelAccommodationEmissionFactors',
  //   type: 'section',
  //   title: 'Otel Konaklama Emisyonları',
  //   branch: '',
  //   translate: 'MENU.HOTEL_ACCOMMODATION_EMISSIONS.SECTION',
  //   role: ['ApplicationAdmin', 'SuperAdmin'],
  //   permission: [''],
  //   icon: 'fs-2 ki-outline ki-home-2',
  //   activeIcon:
  //     '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
  //   url: '/applicationadmin/hotel-accommodation-emission-factors',
  //   activeUrl: false,
  // },
  // {
  //   id: 'emissionFactorConstants',
  //   type: 'item',
  //   title: 'Emission Factor Constants',
  //   translate: 'MENU.CALCULATION.EMISSION_FACTOR_CONSTANTS',
  //   role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
  //   permission: [''],
  //   icon: 'fs-2 ki-outline ki-setting-3',
  //   url: '/emission-factor-constants',
  //   activeUrl: false,
  // },

  {
    id: 'emissionFactors',
    type: 'item',
    title: 'Emission Factors',
    translate: 'MENU.CALCULATION.EMISSION_FACTORS',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
    permission: [''],
    permissions: [...EMISYON_FAKTORLERI_FEATURE_PERMISSIONS],
    icon: 'fs-2 ki-outline ki-setting-3',
    activeUrl: false,

    children: [
      {
        id: 'emissionFactorConstants',
        type: 'item',
        title: 'Emission Factor Constants',
        translate: 'MENU.CALCULATION.EMISSION_FACTOR_CONSTANTS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.Sabitler],
        icon: 'fs-2 ki-outline ki-setting-4',
        url: '/emission-factor-constants',
        activeUrl: false,
      },
      {
        id: 'sourceEmissionFactors',
        type: 'item',
        title: 'Source emission factors',
        translate: 'MENU.CALCULATION.SOURCE_EMISSION_FACTORS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.Kaynak],
        icon: 'fs-2 ki-outline ki-chart-line-up',
        url: '/source-emission-factors',
        activeUrl: false,
      },
      {
        id: 'logisticFactors',
        type: 'item',
        title: 'Logistic emission factors',
        translate: 'MENU.CALCULATION.LOGISTIC_FACTORS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.Lojistik],
        icon: 'fs-2 ki-outline ki-truck',
        url: '/logistic-factors',
        activeUrl: false,
      },
      {
        id: 'hotelAccommodationEmissionFactors',
        type: 'item',
        title: 'Hotel Accommodation Emissions',
        branch: '',
        translate: 'MENU.CALCULATION.HOTEL_ACCOMMODATION_EMISSIONS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.OtelKonaklama],
        icon: 'fs-2 ki-outline ki-home-2',
        url: '/applicationadmin/hotel-accommodation-emission-factors',
        activeUrl: false,
      },
      {
        id: 'emissionSourceCreation',
        type: 'item',
        title: 'Emission Source Creation',
        branch: '',
        translate: 'MENU.EMISSION_SOURCE_CREATION.SECTION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.EmisyonKaynagiOlusturma],
        icon: 'fs-2 ki-outline ki-plus-square',
        url: '/applicationadmin/emission-source-creation',
        activeUrl: false,
      },
      {
        id: 'emissionCategoryMethods',
        type: 'item',
        title: 'Category Methods',
        branch: '',
        translate: 'MENU.EMISSION_CATEGORY_METHODS',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.KategoriMetotlari],
        icon: 'fs-2 ki-outline ki-setting-4',
        url: '/applicationadmin/emission-category-methods',
        activeUrl: false,
      },
      {
        id: 'conversionParameters',
        type: 'item',
        title: 'Conversion Parameters',
        branch: '',
        translate: 'MENU.CONVERSION_PARAMETERS',
        role: ['SuperAdmin', 'ApplicationAdmin'],
        permission: [''],
        icon: 'fs-2 ki-outline ki-arrows-loop',
        url: '/applicationadmin/conversion-parameters',
        activeUrl: false,
      },
    ],
  },
  {
    // Permission bazli gorunurluk: SabitYanmaV2 read grant'i olan her rol gorur.
    id: 'emissionFactorV2',
    type: 'item',
    title: 'EmissionFactor V2',
    translate: 'MENU.EMISSION_FACTOR_V2.SECTION',
    role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
    permission: [''],
    icon: 'fs-2 ki-outline ki-abstract-26',
    activeUrl: false,

    children: [
      {
        id: 'stationaryCombustionFactorsV2',
        type: 'item',
        title: 'Stationary combustion factors',
        translate: 'MENU.EMISSION_FACTOR_V2.STATIONARY_COMBUSTION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.Kaynak],
        icon: 'fs-2 ki-outline ki-setting-4',
        url: '/emission-factor-v2/stationary-combustion-factors',
        activeUrl: false,
      },
      {
        id: 'mobileCombustionFactorsV2',
        type: 'item',
        title: 'Mobile combustion factors',
        translate: 'MENU.EMISSION_FACTOR_V2.MOBILE_COMBUSTION',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.Kaynak],
        icon: 'fs-2 ki-outline ki-truck',
        url: '/emission-factor-v2/mobile-combustion-factors',
        activeUrl: false,
      },
      {
        id: 'electricityCombustionFactorsV2',
        type: 'item',
        title: 'Purchased electricity factors',
        translate: 'MENU.EMISSION_FACTOR_V2.PURCHASED_ELECTRICITY',
        role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
        permission: [''],
        permissions: [P.EmisyonFaktorleri.Kaynak],
        icon: 'fs-2 ki-outline ki-electricity',
        url: '/emission-factor-v2/electricity-combustion-factors',
        activeUrl: false,
      },
    ],
  },

  // {
  //   id: 'reporting',
  //   type: 'section',
  //   title: 'reporting',
  //   branch: '',
  //   translate: 'MENU.REPORTS.REPORT',
  //   role: ['SuperAdmin', 'ApplicationAdmin', 'Admin', 'User'],
  //   permission: [''],
  //   icon: 'fs-2 ki-outline ki-file-sheet',
  //   activeIcon:
  //     '../../../../../../assets/media/icons/jtricons/jtr-admin-active.svg',
  //   url: '/reporting',
  //   activeUrl: false,
  // },
  // {
  //   id: 'dropdown',
  //   type: 'accordion',
  //   title: 'MENU.TESTMENU.HEADER',
  //   branch: '',
  //   translate: 'MENU.TESTMENU.SECTION',
  //   role: ['Admin', 'SuperAdmin', 'ApplicationAdmin'],
  //   permission: [''],
  //   icon: 'fs-2 ki-outline ki-element-plus',
  //   activeIcon: '../../../../../../assets/media/icons/jtricons/consignment-active.svg',
  //   url: '',
  //   activeUrl: false,
  //   children: [
  //     {
  //       id: 'submenu',
  //       title: 'SubMenu',
  //       translate: 'MENU.TESTMENU.SUBMENU',
  //       role: ['Admin', 'SuperAdmin', 'ApplicationAdmin'],
  //       permission: [''],
  //       type: 'item',
  //       branch: '',
  //       icon: 'star',
  //       url: '/testpage',
  //       activeUrl: false,
  //     },
  //     {
  //       id: 'submenu2',
  //       title: 'SubMenu2',
  //       translate: 'MENU.TESTMENU.SUBMENU2',
  //       role: ['Admin', 'SuperAdmin', 'ApplicationAdmin'],
  //       permission: [''],
  //       type: 'item',
  //       branch: '',
  //       icon: 'star',
  //       url: '',
  //       activeUrl: false,
  //       children: [
  //         {
  //           id: 'submenusub',
  //           title: 'SubMenuSub',
  //           translate: 'MENU.TESTMENU.SUBMENU2SUB.TESTSUBMENU',
  //           role: ['Admin', 'SuperAdmin', 'ApplicationAdmin'],
  //           permission: [''],
  //           type: 'item',
  //           branch: '',
  //           icon: 'star',
  //           url: '/testpage',
  //           activeUrl: false,
  //         },
  //         {
  //           id: 'submenusub2',
  //           title: 'SubMenuSub2',
  //           translate: 'MENU.TESTMENU.SUBMENU2SUB.TESTSUBMENU2',
  //           role: ['Admin', 'SuperAdmin', 'ApplicationAdmin'],
  //           permission: [''],
  //           type: 'item',
  //           branch: '',
  //           icon: 'star',
  //           url: '/testpage',
  //           activeUrl: false,
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const menu = filterSidebarMenuItems(SIDEBAR_MENU_ITEMS);
